import { COLUMN_DEFINITIONS as payoutColumnDefs } from "./payout.pdf-table.config";
import { COLUMN_DEFINITIONS as jobColumnDefs } from "./job.pdf-table.config";
import { COLUMN_DEFINITIONS as invoiceColumnDefs } from "./invoice.pdf-table.config";
import { COLUMN_DEFINITIONS as manifestColumnDefs } from "./manifest.pdf-table.config";

// Add default configuration
const defaultConfig = {
  COLUMN_DEFINITIONS: [],
};

export const getPdfConfig = (modelName) => {
  if (!modelName) return { pdfConfig: defaultConfig };

  try {
    const configs = {
      Payout: {
        COLUMN_DEFINITIONS: payoutColumnDefs || [],
      },
      Payouts: {
        COLUMN_DEFINITIONS: payoutColumnDefs || [],
      },
      Job: {
        COLUMN_DEFINITIONS: jobColumnDefs || [],
      },
      Jobs: {
        COLUMN_DEFINITIONS: jobColumnDefs || [],
      },
      Invoice: {
        COLUMN_DEFINITIONS: invoiceColumnDefs || [],
      },
      Invoices: {
        COLUMN_DEFINITIONS: invoiceColumnDefs || [],
      },
      Manifest: {
        COLUMN_DEFINITIONS: manifestColumnDefs || [],
      },
      Manifests: {
        COLUMN_DEFINITIONS: manifestColumnDefs || [],
      },
    };

    return {
      pdfConfig: configs[modelName] || defaultConfig,
    };
  } catch (error) {
    console.error("Error in getPdfConfig:", error);
    return { pdfConfig: defaultConfig };
  }
};

// Make sure we're exporting correctly
export default getPdfConfig;










